module.exports = __webpack_public_path__ + "media/assets/icons/pipeline-design-69626912b195d26430e30bb3aee9f877.svg";